<template>

    <ValidationObserver ref="form">
        <h2 class="profile__title">Location Information </h2>
        <div class="row mb-5">

            <ValidationProvider
                class="col-md-6"
                name="Home Airport"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Home Airport (City, State, Airport Code)*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="locationInfo.airport"
                    >
                    <FormError :error="errors[0]"  name="Home Airport"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Alternative Airport"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Alternative Home Airport (City, State, Airport Code)**</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="locationInfo.alternative_airport"
                    >
                    <FormError :error="errors[0]"  name="Alternative Airport"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Global Region"
                v-slot="{ errors }"
                rules="required"
                mode="lazy"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Global Region</label>
                    <FormError :error="errors[0]" name="Global Region"></FormError>
                    <VueMultiSelect
                        :options="regions"
                        :selected_options="locationInfo.global_region"
                        v-model="locationInfo.global_region"
                    ></VueMultiSelect>
                </div>

            </ValidationProvider>
        </div>
    </ValidationObserver>

</template>

<script>
import FormError from "../Common/FormError.vue";
import {mapActions, mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import commonLists from "../../mixins/commonLists";

export default {
    name: "LocationInfo",
    components: {FormError},
    mixins: [commonLists],
    computed: {
        ...mapState(useArtistStore, {
            locationInfo: 'locationInfo',
            regions: 'regions'
        })
    },
    watch: {
        locationInfo: {
            handler(state) {
                this.dispatchState(state);
            },
            deep: true
        }
    }
}

</script>

<style scoped>

</style>
